export const INITIAL_HANDLE_BUSINESS_TIME = {
  days_of_week: [],
  open_time: '',
  order_start_time: '',
  last_order_time: '',
  last_pickup_time: '',
  relative_pickupable_time: '0',
}
